__webpack_require__.p = "/HandwrittenAi/";